interface TocItem {
  id: string;
  label: string;
}

export default function EntryToc({ items }: { items: TocItem[] }) {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <aside className="lg:sticky lg:top-28">
      <div className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
          <i className="ri-list-check-2 text-primary-600" />
          词条目录
        </h2>
        <nav className="mt-4">
          <ul className="space-y-1">
            {items.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={() => scrollTo(item.id)}
                  className="block w-full rounded-md px-3 py-2 text-left text-sm text-foreground-600 transition-colors hover:bg-background-200 hover:text-primary-600"
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </aside>
  );
}